import { useState } from "react";
import { Subscription } from "@appTypes/index";
import { SUBSCRIPTION_SOURCES } from "@constants/subscriptions";
import enableStripeSubscriptionAutoRenewal from "@api/enableStripeSubscriptionAutoRenewal";
import enableZuoraSubscriptionAutoRenewal from "@api/enableZuoraSubscriptionAutoRenewal";
import { useSubscriptionContext } from "@context/SubscriptionContext";

const useRenewPremiumSubscription = (subscription: Subscription) => {
  const [isRenewing, setIsRenewing] = useState(false);
  const [renewError, setRenewError] = useState<string | null>(null);
  const { updateSubscriptionLocally } = useSubscriptionContext();

  const handleRenew = async (onSuccess?: () => void): Promise<void> => {
    if (!subscription.subscriptionIdentifier) {
      setRenewError("Unable to renew: subscription identifier is missing.");
      return;
    }

    const { subscriptionIdentifier } = subscription;
    const isStripe = subscription.source === SUBSCRIPTION_SOURCES.STRIPE;

    setIsRenewing(true);
    setRenewError(null);

    const response = isStripe
      ? await enableStripeSubscriptionAutoRenewal(subscriptionIdentifier)
      : await enableZuoraSubscriptionAutoRenewal(subscriptionIdentifier);

    setIsRenewing(false);
    if (response.success) {
      updateSubscriptionLocally(subscriptionIdentifier, { autoRenew: true });
      onSuccess?.();
    } else {
      setRenewError(response.error);
    }
  };

  return { handleRenew, isRenewing, renewError };
};

export default useRenewPremiumSubscription;
